import './table.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { HEADERS, PERMISSIONS } from '../../config';
import { Button } from '..';
import { DataTable } from './table';
import { useHasPermission } from '../../hooks';

const TeamsTableWrapper = ({
  data,
  exportData,
  name,
  headerName,
  title,
  link,
  onLoadMore,
  canLoadMore,
  hasFilters,
  isLoading,
  isFetching,
  onSearch,
  searchPlaceholder,
  onStatusChange,
  onDateFilter,
  emptyDataComponent,
  rowClick,
  exportUrl,
  ...props
}) => {
  const hasPermission = useHasPermission();
  const canInviteTeamMember = hasPermission(PERMISSIONS.TEAMS_MANAGE);

  return (
    <div className="card table-wrapper ">
      <div className="card__header">
        <h3 className="card__title">
          {title} <span className="text-cursive">{name}</span>
        </h3>
        {canInviteTeamMember && (
          <div>
            <Button variant="solid" onClick={props.openModal}>
              Invite Member
            </Button>
          </div>
        )}
      </div>

      <DataTable
        isFetching={isFetching}
        headers={HEADERS[headerName]}
        data={data}
        emptyDataComponent={emptyDataComponent}
        rowClick={rowClick}
      />
    </div>
  );
};

TeamsTableWrapper.defaultProps = {
  linkPosition: 'bottom'
};

TeamsTableWrapper.propTypes = {
  data: PropTypes.array,
  name: PropTypes.string,
  headerName: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onLoadMore: PropTypes.func,
  onSearch: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  onStatusChange: PropTypes.func,
  onDateFilter: PropTypes.func,
  canLoadMore: PropTypes.bool,
  hasFilters: PropTypes.bool,
  isLoading: PropTypes.bool,
  isFetching: PropTypes.bool,
  openModal: PropTypes.func,
  emptyDataComponent: PropTypes.element,
  exportData: PropTypes.bool,
  addOn: PropTypes.element,
  rowClick: PropTypes.func
};

export { TeamsTableWrapper };
